import React, { FC, useState } from 'react';
import TimeSelectors from './components';
import { TDropdownContextSendData, TTimeDropdownContextSendData, TTimeField } from '../../types/timeField.types';
import useDidUpdate from '../../../../hooks/useDidUpdate.effect';
import './style.scss';

const convertObjectToString = (obj) => {
  const objKeys = Object.keys(obj);
  if (objKeys.length === 0) {
    return '';
  }
  return objKeys?.map((key) => obj[key]).join('|');
};

const defaultSendData = {
  value: [
    {
      hours: '',
      minutes: '',
      meridiem: '',
    },
  ],
};

const TimeField: FC<TTimeField> = (props) => {
  const { field } = props;
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;
  const FieldValidationErrors = props?.fieldValidationErrorsComponent;
  const [value, setValue] = useState('');
  const [sendData, setSendData] = useState<TTimeDropdownContextSendData>(() => defaultSendData);

  const updateSendData = (newSendData: Partial<TDropdownContextSendData> = {}) => {
    setSendData((prevState) => ({
      ...prevState,
      value: prevState.value.map((item) => ({ ...item, ...newSendData })),
    }));
  };

  useDidUpdate(() => {
    const sendTimeValue = sendData?.value?.map((obj) => convertObjectToString(obj)).join('');
    setValue(sendTimeValue);
    props.onChange(field.valueField.name, sendTimeValue, props.isValid, []);
  }, [sendData]);

  return (
    <div className="sitecore-jss-form__control--time-selectors-wrapper">
      <input id={id} name={name} className="sitecore-jss-form__field" type="hidden" value={value} form="novalidatedform" />

      {field?.model?.placeholderText && <div className="sitecore-jss-form__control--time-selectors__eyebrow">{field?.model?.placeholderText}</div>}
      <div className="sitecore-jss-form__control--time-selectors-list">
        <TimeSelectors
          fields={props}
          updateSendData={updateSendData}
          hideMeridiemSelector={field?.model?.time24HoursFormat}
          minutesInterval={field?.model?.timeInterval}
          hourMinutesFormat={field?.model?.hourMinutesFormat}
        />
      </div>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default TimeField;
